import { actionCreatorFactory } from 'typescript-fsa';
import { MyDealersModel } from 'da-pcc-frontend-shared-domain';

const createAction = actionCreatorFactory('DEALER');
const fetchMyDealers = createAction.async<void, MyDealersModel | undefined, Error>('REQUESTED');

export { fetchMyDealers };
